import React, { useContext, useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import PrimaryButton from '../../atoms/PrimaryButton'
import UserContext from '../../../context/user/userContext'
import { useFormik } from 'formik'
import CommonContext from '../../../context/common/commonContext'
import Loaders from '../../../components/molecules/Loaders'
import AuthContext from '@/product/context/auth/authContext'
import { mapData, dateTimeFormatFunction } from '../../../common/components'
import { initialFilterFunction } from '../../species/dynamic/common/FieldFunction'
import * as Yup from 'yup'
import moment from 'moment'
import CustomDialog from '../Dialog'
import BaseTablePage from '../../species/dynamic/common/BaseTablePage'
import { Button } from '@mui/material'
import { Buffer } from 'buffer'
import { useTranslation } from 'react-i18next'
import { handleRedirectInternal } from '@/custom/common/components'
// import { openSwitchUserTab } from '@/product/common/urlValidation'
import CustomCommonContext from '@/custom/context/common/commonContext'
import BuyerJourney from '@/product/components/organisms/User/BuyerJourney'
import { switchUserControl } from '@/product/common/switchUserControl'

const UserCommonTable = (props) => {
    const authContext = useContext(AuthContext)
    const { user } = authContext
    const { t } = useTranslation()

    const {
        all_users,
        changeUserStatus,
        changeSellerStatus,
        getAllUsers,
        userAction,
        responseStatus: responseStatusUser,
        clearResponse: clearResponseUser,
    } = useContext(UserContext)

    const history = useHistory()

    const commonContext = useContext(CommonContext)
    // `|| {}` because this product component is shared by apps that may render
    // it outside CustomCommonState, where useContext yields the createContext
    // default of undefined and destructuring would throw. An app with no
    // configFeatures simply gets the legacy switch-user contract.
    const { configFeatures } = useContext(CustomCommonContext) || {}
    const [isLoading, setIsLoading] = useState(true)
    const [initialValues, setInitialValues] = useState({})
    const [initialSimilarValues, setInitialSimilarValues] = useState({})
    const [initialUpdate, setInitialUpdate] = useState(true)
    const [initialEmptyValues, setInitialEmptyValues] = useState({})
    const [filterArray, setFilterArray] = useState({})
    const [reload, setReload] = useState(false)

    const validationArray = Yup.object({
        reject_notes: Yup.string().when(['additionalUpdate'], {
            is: (a) => a,
            then: Yup.string().required('Required'),
        }),
    })

    /* Start of Formik Selection Action Function */
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            user_id: '',
            reject_notes: '',
            additionalUpdate: true,
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            if (
                values.action === 'active' ||
                values.action === 'deactivate' ||
                values.action === 'rejected'
            ) {
                if (global?.sellerStatusFeature) {
                    changeSellerStatus(values)
                } else {
                    changeUserStatus(values)
                }
            }
        },
    })
    /* End of Formik Selection Action Function */

    /* Start of Fetch Table Body Function */
    const [tableBody, setTableBody] = useState([])
    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
        user_type: 0,
    })

    const toggleFullScreenPopup = (popup, status, id, user_type) => {
        if (
            status === 'edit' &&
            (user?.emp_type === 'super_admin' || user?.emp_type === 'admin')
        ) {
            handleRedirectInternal(history, `user/edit/${id}`)
        } else if (popup) {
            setManage({ popup, status, id, user_type })
        } else {
            setManage({ popup: false, status: 'new', id: 0, user_type: 0 })
        }
    }

    let action = props.action

    const formik = useFormik({
        initialValues: {
            limit: global?.zb_custom_table_limit || 20,
            page: 1,
            orderby: '',
            order: '',
            filters: initialValues,
            similars: initialSimilarValues,
        },
        enableReinitialize: false,
        onSubmit: (values) => {
            setIsLoading(true)
            getAllUsers(values)
        },
    })
    useEffect(() => {
        if (props.requestUserAccess) {
            if (formik.values.filters && initialSimilarValues) {
                if (initialSimilarValues.both) {
                    let initial = { ...props.customSimilar }
                    if (formik.values.filters.is_requested?.value) {
                        initial.both.value = '0'
                        formik.values.filters.both = initial.both
                        if (props.seller) {
                            initial.admin.value = '1'
                        } else {
                            initial.admin.value = '0'
                            formik.values.filters.admin = initial.admin
                        }
                        setInitialSimilarValues(initial)
                    } else {
                        if (props.seller) {
                            initial.admin.value = '1'
                        } else {
                            initial.admin.value = '0'
                        }
                        delete formik.values.filters.admin
                        initial.both.value = '1'
                        setInitialSimilarValues(initial)
                    }
                } else {
                    if (formik.values.filters.is_requested?.value) {
                        formik.values.filters.both = {
                            value: '0',
                            type: 'in',
                            field: 'cu.both_access',
                        }
                    } else {
                        delete formik.values.filters.both
                    }
                }
            }
        }
    }, [formik.values?.filters?.is_requested])
    useEffect(() => {
        setTableBody([])
        if (!formik.values.filters.action) return
        setIsLoading(true)
        formik.values.filters.action.value = action
        formik.values.page = 1

        getAllUsers(formik.values)
        /*  return () => {
            setTableBody([])
        }*/
    }, [action, formik.values.filters.action])
    useEffect(() => {
        if (all_users) {
            if (
                global?.userStatusChange &&
                all_users?.records &&
                all_users?.records?.length
            ) {
                all_users.records.map((ele) => {
                    if (
                        ele.status === 'unverified' ||
                        ele.seller_status === 'unverified'
                    ) {
                        ele.status = 'awaiting admin approval'
                        ele.seller_status = 'awaiting admin approval'
                    } else if (
                        ele.status === 'deactivate' ||
                        ele.seller_status === 'deactivate'
                    ) {
                        ele.status = 'suspended'
                        ele.seller_status = 'suspended'
                    }
                })
            }
            setTableBody(all_users.records.length ? all_users.records : [])
        }
        setIsLoading(false)
    }, [all_users])
    /* End of Fetch Table Body Function */
    useEffect(() => {
        formik.setFieldValue('filters', initialValues)
    }, [initialValues])
    useEffect(() => {
        formik.setFieldValue('similars', initialSimilarValues)
    }, [initialSimilarValues])
    /* Start Dynamic filter handle */
    useEffect(() => {
        setInitialValues({})
        setInitialSimilarValues({})
        setInitialEmptyValues({})
        setInitialUpdate(true)

        if (props.searchInfo.data && props.searchInfo.data.length) {
            let mapValueArray = props.searchInfo.data
            let show = initialFilterFunction(mapValueArray)
            setInitialValues({ ...props.customFilter, ...show })
            if (props.customSimilar)
                setInitialSimilarValues({ ...props.customSimilar })
            setInitialEmptyValues({ ...props.customFilter, ...show })
            setFilterArray(props.searchInfo)

            setTimeout(() => {
                if (Object.keys(show).length) {
                    setInitialUpdate(false)
                    setReload(!reload)
                }
            }, 1000)
        } else {
            setInitialValues(props.customFilter)
            if (props.customSimilar)
                setInitialSimilarValues({ ...props.customSimilar })
            setInitialEmptyValues(props.customFilter)

            setTimeout(() => {
                if (Object.keys(props.customFilter).length) {
                    setInitialUpdate(false)
                    setReload(!reload)
                }
            }, 1000)
        }
    }, [props.searchInfo])
    /* End Dynamic filter handle */

    /* Start of Listing Edit Functions */
    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'Comment') {
            props.toggleDrawer(true, id)
        } else if (type === 'loginHistory') {
            props.toggleFullScreenPopup(true, 'loginHistory', id)
        } else if (type === 'buyer_journey') {
            toggleFullScreenPopup(true, 'buyer_journey', id)
        } else {
            props.toggleFullScreenPopup(true, 'edit', id, secondaryID)
        }
    }

    const onClickSwitchUser = async (id, email) => {
        if (props?.isEmp) {
            let btoaEmail = btoa(email)
            handleRedirectInternal(history, `switch?user_id=${btoaEmail}`)
        } else {
            const opened = await switchUserControl(id)
            if (!opened) {
                setAlert(
                    'Unable to switch user. Check your permission and allow popups.',
                    'error'
                )
            }
        }
    }

    const onClickCancelRequest = (id) => {
        userAction({ id: id, is_requested: 0 }, 'updateRequest')
    }

    const getMultipleAction = () => {
        let actionPush = []
        if (!(action === 'closed')) {
            actionPush.push({
                field: 'action',
                type: 'button',
                clickType: 'edit',
                onclick: onClickEdit,
                secondaryClickID: 'user_id',
                sort: false,
                firstChild: false,
                disablePadding: false,
                label: t('Action'),
                tooltipTitle: 'Edit user',
            })
            if (global?.buyer_journey) {
                actionPush.push({
                    field: 'action',
                    type: 'button',
                    clickType: 'buyer_journey',
                    clickID: 'id',
                    buttonType: 'visibility',
                    onclick: onClickEdit,
                    sort: false,
                    firstChild: false,
                    disablePadding: false,
                    label: 'Action',
                    tooltipTitle: 'Buyer Journey',
                })
            }

            if (props.listActionString && props.listActionString.length) {
                if (props.listActionString.includes('loginHistory')) {
                    actionPush.push({
                        field: 'action',
                        type: 'button',
                        buttonType: 'history',
                        clickType: 'loginHistory',
                        onclick: onClickEdit,
                        sort: false,
                        firstChild: false,
                        disablePadding: false,
                        label: t('Action'),
                        tooltipTitle: 'Login History',
                    })
                }

                if (props.listActionString.includes('switchuser')) {
                    if (user?.emp_type === 'super_admin') {
                        actionPush.push({
                            field: 'action',
                            type: 'button',
                            buttonType: 'visibility',
                            clickType: 'switchuser',
                            onclick: onClickSwitchUser,
                            sort: false,
                            firstChild: false,
                            disablePadding: false,
                            label: t('Action'),
                            tooltipTitle: 'Switch user',
                            secondaryClickID: 'email',
                        })
                    }
                }

                if (props.listActionString.includes('cancelrequest')) {
                    if (user?.emp_type === 'super_admin') {
                        actionPush.push({
                            field: 'action',
                            type: 'button',
                            buttonType: 'cancel',
                            clickType: 'switchuser',
                            condition: true,
                            conditionValue: {
                                formula: {
                                    key1: 'is_requested',
                                    key2: 1,
                                    notation: '===',
                                },
                            },
                            onclick: onClickCancelRequest,
                            sort: false,
                            firstChild: false,
                            disablePadding: false,
                            label: t('Action'),
                            tooltipTitle: 'Switch user',
                        })
                    }
                }
            }
        }
        return actionPush
    }

    /* End of Listing Edit Functions */

    /* Start of Table Top Action Function */
    const [changeStatus, setChangeStatus] = useState(false)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }
    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.user_id = data
        formikSelection.values.additionalUpdate =
            action === 'deactivated' ||
            action === 'deactivate' ||
            action === 'rejected'
                ? true
                : false
        formikSelection.values.reject_notes = ''
        if (
            action === 'active' ||
            action === 'deactivate' ||
            action === 'deactivated' ||
            action === 'rejected'
        ) {
            setChangeStatus(true)
        }
    }

    useEffect(() => {
        if (responseStatusUser) {
            if (responseStatusUser.status === 'success') {
                if (responseStatusUser.from === 'changeStatus') {
                    setChangeStatus(false)
                    getAllUsers(formik.values)
                }
                if (responseStatusUser.from === 'userAction') {
                    props.toggleFullScreenPopup(false)
                    getAllUsers(formik.values)
                }
                if (responseStatusUser.from === 'bulkUserAction') {
                    getAllUsers(formik.values)
                }
                if (responseStatusUser.from === 'updateRequest') {
                    getAllUsers(formik.values)
                }
            }
        }
    }, [responseStatusUser])
    /* End of Table Top Action Function */

    /* Start of Table Top Value Function */
    const [tableActions, setTableActions] = useState([])
    let incomingAction = props.tableActionString

    useEffect(() => {
        let tempTableActions = [
            {
                label: t('Move to De-active'),
                icon: <span className="material-icons">block</span>,
                onclick: onSelectMultiProducts,
                type: 'deactivate',
                action: 'active',
            },
            {
                label: t('Move to Active'),
                icon: <span className="material-icons">check_circle</span>,
                onclick: onSelectMultiProducts,
                type: 'active',
                action: 'deactivate',
            },
            {
                label: t('Move to Active'),
                icon: <span className="material-icons">check_circle</span>,
                onclick: onSelectMultiProducts,
                type: 'active',
                action: 'unverified',
            },
            {
                label: t('Move to Rejected'),
                icon: <span className="material-icons">cancel</span>,
                onclick: onSelectMultiProducts,
                type: 'rejected',
                action: 'active',
            },
            {
                label: t('Move to De-active'),
                icon: <span className="material-icons">block</span>,
                onclick: onSelectMultiProducts,
                type: 'deactivate',
                action: 'all' || action,
            },
            {
                label: t('Move to Active'),
                icon: <span className="material-icons">check_circle</span>,
                onclick: onSelectMultiProducts,
                type: 'active',
                action: 'all' || action,
            },

            {
                label: t('Move to Rejected'),
                icon: <span className="material-icons">cancel</span>,
                onclick: onSelectMultiProducts,
                type: 'rejected',
                action: 'all' || action,
            },
        ]

        tempTableActions = tempTableActions.filter((d) =>
            d.action
                .toString()
                .split(',')
                .includes(action || null) && incomingAction.length
                ? incomingAction.includes(d.type)
                : false
        )
        if (action === null) {
            tempTableActions.push(
                {
                    label: t('Move to De-activate'),
                    icon: <span className="material-icons">block</span>,
                    onclick: onSelectMultiProducts,
                    type: 'deactivate',
                },
                {
                    label: t('Move to Activate'),
                    icon: <span className="material-icons">check_circle</span>,
                    onclick: onSelectMultiProducts,
                    type: 'active',
                },

                {
                    label: t('Move to Rejected'),
                    icon: <span className="material-icons">cancel</span>,
                    onclick: onSelectMultiProducts,
                    type: 'rejected',
                }
            )
        }
        tempTableActions = tempTableActions.filter((d) =>
            d.type && incomingAction.length
                ? incomingAction.includes(d.type)
                : false
        )
        if (
            !tempTableActions.length &&
            props?.notActiveAction?.length &&
            props?.notActiveAction?.includes(action)
        ) {
            tempTableActions.push({
                label: t('Move to Activate'),
                icon: <span className="material-icons">check_circle</span>,
                onclick: onSelectMultiProducts,
                type: 'active',
            })
        }
        setTableActions(tempTableActions)
    }, [action, incomingAction])

    /* End of Table Top Value Function */

    /* Start of Table Body Value Function */
    const [arrayValue, setArrayValue] = useState([])
    useEffect(() => {
        if (props.tableValue.length) {
            let dynamicValueAssign = props.tableValue

            // dynamicValueAssign = dynamicValueAssign.filter((item) =>
            //     item.field !== 'action'
            //         ? action !== 'sold' && action !== 'relisted'
            //             ? item.field !== 'winner_email' &&
            //               item.field !== 'buynow_common_invoice' &&
            //               item.field !== 'buynow_paid_date' &&
            //               item.field !== 'buynow_qty' &&
            //               item.field !== 'buynow_amount' &&
            //               item.field !== 'winner_first_name,winner_last_name'
            //             : action === 'open'
            //             ? item.field !== 'wprice'
            //             : true
            //         : false,
            // )
            if (
                action === 'deactivate' ||
                action === 'deactivated' ||
                action === 'rejected'
            ) {
                dynamicValueAssign.push({
                    field: 'reject_notes',
                    type: '',
                    sort: true,
                    firstChild: false,
                    disablePadding: false,
                    label: t('Notes'),
                    tableShow: 1,
                })
            }
            let index = dynamicValueAssign.findIndex((e) => e.field == 'action')
            if (index < 0) {
                dynamicValueAssign.push({
                    name: 'action',
                    field: 'action',
                    type: 'button',
                    clickID: 'id',
                    sort: false,
                    firstChild: false,
                    disablePadding: false,
                    label: t('Action'),
                    isMultiple: getMultipleAction(),
                    tableShow: 1,
                })
            }

            setArrayValue(dynamicValueAssign)
        }
    }, [props.tableValue, action, configFeatures])
    /* End of Table Body Value Function */

    /* Start of Bulk Upload Function */

    /* End of Bulk Upload Function */

    /* Start of Search Info Function */

    const searchInfo = filterArray.data?.length
        ? { formik: formik, ...filterArray }
        : { formik: formik }
    /* End of Search Info Function */

    /* Start Auction Lot Action Function */

    /* End of Auction Lot Action Function */

    const rejectNotes = {
        formik: formikSelection,
        data: [
            {
                label: 'Justification Notes',
                placeholder: 'Enter Justification Notes',
                class: `col-12 ${
                    formikSelection.values.additionalUpdate ? '' : 'd-none'
                }`,
                type: 'textarea',
                name: 'reject_notes',
                filter: true,
            },
        ],
    }

    /* Start Date Close Function */
    /* End  Date Close Function */

    const resetForm = () => {
        formik.values.filters = initialEmptyValues
    }

    return (
        <>
            <div className="dashboard listing maillisting">
                {initialUpdate ? (
                    <Loaders name="table" isLoading={isLoading} />
                ) : (
                    <BaseTablePage
                        arrayValue={arrayValue}
                        isLoading={isLoading}
                        searchInfo={searchInfo}
                        tableBody={tableBody}
                        tableActions={tableActions}
                        allData={all_users}
                        changeTableFunction={getAllUsers}
                        hideCompactView={props.hideCompactView}
                        advFilters={props.advFilters}
                        resetForm={resetForm}
                        columnStorageVariable={props.columnStorageVariable}
                    />
                )}
            </div>
            <BuyerJourney data={manage} function={toggleFullScreenPopup} />

            <CustomDialog
                title={t('Change user status')}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>{t('Are you sure you want to change the status')}</h5>
                <div className="row">{mapData(rejectNotes)}</div>
                <div className="actionWrapper">
                    <Button
                        id="user_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="user_table_status"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </>
    )
}

export default UserCommonTable
